// Detectar cuándo la section está pasando en el viewport y activar Tab si existe



function detectionActiveTab() {

    const tabs = document.querySelectorAll(".tab-group.sticky:not(.is_tab_content)");

     if(!tabs) {
        return;
     }

     tabs.forEach((tab) => {

         const sections = document.querySelectorAll(
            ".entry-content section[id], .entry-content div[id]:not(#sc-products)"
         );

         sections.forEach((section) => {
            const sectionId = section.getAttribute("id");
            
            window.addEventListener("scroll", ()=> {
               const sectionIdOffset = section.getBoundingClientRect().top;

           
               if(sectionIdOffset < 0){
                  const links = tab.querySelectorAll("ul li a");
                  links.forEach((link) => {

                     if(link.getAttribute("href").includes("#")) {
                        const linkId = link.getAttribute("href").replace('#', '');;

                        if(sectionId === linkId){
                           link.classList.add("active")
                        } else {
                           link.classList.remove("active")
                        }
                     }
                     
                  })
               }

            })
         })
     })
}

detectionActiveTab()

